export const REDIRECT_URL = 'redirectUrl';
